module.exports = __webpack_public_path__ + "static/media/3655E8_2_0.100e1faa.woff2";